import {Actor, RejectionReason} from '@muvio/honda-offers-builder/model'

import {Variant} from '@/components/atom/MChip/types'

export const REJECTION_REASON_KEYS: Record<RejectionReason, string> = {
  [RejectionReason.Price]: 'price',
  [RejectionReason.Financing]: 'financing',
  [RejectionReason.Features]: 'features',
  [RejectionReason.Communication]: 'communication',
  [RejectionReason.Model]: 'model',
  [RejectionReason.Other]: 'other',
}

type Translator = (key: string) => string

export function buildRejectionTooltip(offer: any, t: Translator): string {
  if (offer.rejectionReasonCustom) return offer.rejectionReasonCustom
  const key = offer.rejectionReason ? REJECTION_REASON_KEYS[offer.rejectionReason as RejectionReason] : undefined
  return key ? t(`offers.reject-dialog.reasons.${key}`) : ''
}

export function refusedStatusChip(offer: any, text: string, t: Translator) {
  const isCustomerEmail = offer.rejectedBy === Actor.Customer || (!offer.rejectedBy && offer.updatedStatusFromEmail)
  const reasonTooltip = buildRejectionTooltip(offer, t)
  const baseTooltip = isCustomerEmail ? t('offers.tooltip.refused-email') : ''
  const tooltip = [baseTooltip, reasonTooltip].filter(Boolean).join(' — ')

  return {
    icon: isCustomerEmail ? 'fa-envelope' : 'fa-xmark',
    text,
    variant: Variant.Error,
    ...(tooltip ? {tooltip} : {}),
  }
}
